import React from 'react';
import { Link } from 'react-router-dom';

const AdminPanel: React.FC = () => (
    <nav
        style={{
            background: '#2575fc',
            color: '#fff',
            borderRadius: '12px',
            padding: '1.5rem 1rem',
            margin: '0 auto',
            maxWidth: 300,
            boxShadow: '0 2px 16px #6a11cb22',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            alignItems: 'stretch'
        }}
    >
        <span style={{ fontWeight: 'bold', textAlign: 'center' }}>Admin Panel</span>
        <Link
            to="/adduser"
            style={{
                borderRadius: 6,
                border: 'none',
                padding: '0.5rem 1rem',
                background: 'inherit',
                color: '#fff',
                cursor: 'pointer',
                textAlign: 'center',
                textDecoration: 'none'
            }}
        >
            Add User
        </Link>
        <Link
            to="/addprogram"
            style={{
                borderRadius: 6,
                border: 'none',
                padding: '0.5rem 1rem',
                background: 'inherit',
                color: '#fff',
                cursor: 'pointer',
                textAlign: 'center',
                textDecoration: 'none'
            }}
        >
            Add Program
        </Link>
        <Link
            to="/addvideo"
            style={{
                borderRadius: 6,
                border: 'none',
                padding: '0.5rem 1rem',
                background: 'inherit',
                color: '#fff',
                cursor: 'pointer',
                textAlign: 'center',
                textDecoration: 'none'
            }}
        >
            Add Video
        </Link>
        <Link
            to="/addcertificate"
            style={{
                borderRadius: 6,
                border: 'none',
                padding: '0.5rem 1rem',
                background: 'inherit',
                color: '#fff',
                cursor: 'pointer',
                textAlign: 'center',
                textDecoration: 'none'
            }}
        >
            Add Certificate
        </Link>
        <Link
            to="/deleteuser"
            style={{
                borderRadius: 6,
                border: 'none',
                padding: '0.5rem 1rem',
                background: 'inherit',
                color: '#fff',
                cursor: 'pointer',
                textAlign: 'center',
                textDecoration: 'none'
            }}
        >
            Delete User
        </Link>
        <Link
            to="/deleteprogram"
            style={{
                borderRadius: 6,
                border: 'none',
                padding: '0.5rem 1rem',
                background: 'inherit',
                color: '#fff',
                cursor: 'pointer',
                textAlign: 'center',
                textDecoration: 'none'
            }}
        >
            Delete Program
        </Link>
        <Link
            to="/deletevideo"
            style={{
                borderRadius: 6,
                border: 'none',
                padding: '0.5rem 1rem',
                background: 'inherit',
                color: '#fff',
                cursor: 'pointer',
                textAlign: 'center',
                textDecoration: 'none'
            }}
        >
            Delete Video
        </Link>
        <Link
            to="/deletecertificate"
            style={{
                borderRadius: 6,
                border: 'none',
                padding: '0.5rem 1rem',
                background: 'inherit',
                color: '#fff',
                cursor: 'pointer',
                textAlign: 'center',
                textDecoration: 'none'
            }}
        >
            Delete Certificate
        </Link>
        <Link
            to="/view"
            style={{
                borderRadius: 6,
                border: 'none',
                padding: '0.5rem 1rem',
                background: 'inherit',
                color: '#fff',
                cursor: 'pointer',
                textAlign: 'center',
                textDecoration: 'none'
            }}
        >
            View
        </Link>
    </nav>
);

export default AdminPanel;